import React, { useState, useEffect } from "react";
import classes from './Suppliers.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, Edit, Trash } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import api, { BASE_URL, withCompanyId } from "../../Components/API/Api"
import SupplierModal from './SupplierModal'
// import PaymentModal from './PaymentModal';
import { Link } from "react-router";
import { Modal, Button, Form, Container, Row, Col } from 'react-bootstrap';
// using central `api` instance instead of raw axios
import swal from 'sweetalert';

const Suppliers = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [editingSupplier, setEditingSupplier] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [selectedMetrics, setSelectedMetrics] = useState(null);


  useEffect(() => {
    const authToken = localStorage.getItem('authToken');

    if (!authToken) {
      setError("Authorization token not found.");
      navigate('/signin');
      return;
    }
    // fetchCustomers defined below and reused after uploads
    fetchCustomers();
  }, [navigate]);

  // Extracted so we can refresh list after an upload without reloading page
  const fetchCustomers = async () => {
    setLoading(true);
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      setError("Authorization token not found.");
      navigate('/signin');
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/v1/beneficiary");
      // backend may return nested shapes; prefer the innermost array when present
      let customerData = [];
      if (Array.isArray(res.data?.data?.data)) customerData = res.data.data.data;
      else if (Array.isArray(res.data?.data)) customerData = res.data.data;
      else customerData = [];

      setCustomers(customerData);
      setError(null);
    } catch (err) {
      console.error("Error fetching customers:", err?.response?.data || err.message);
      setError(err.response?.data?.message || "Failed to fetch customers. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  // Handle edit button click
  const handleEditSupplier = (supplier) => {
    setEditingSupplier(supplier);
    setShowSupplierModal(true);
  };

  // Handle modal close - clear editing state
  const handleModalClose = () => {
    setShowSupplierModal(false);
    setEditingSupplier(null);
  };

  // Callback when supplier is updated - refresh the list
  const handleSupplierUpdated = async () => {
    await fetchCustomers();
  };

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const res = await api.get("/v1/metrics/suppliers-metrics");
        if (res.data && res.data.status && res.data.data) {
          setSelectedMetrics(res.data.data);
        }
      } catch (err) {
        setSelectedMetrics(null);
      } finally {
        setLoading(false);
      }
    };
    fetchMetrics();
  }, []);


  const pageMap = {
    '/dashboard': 'Dashboard',
    '/transactions': 'Transactions',
    '/accounts': 'Accounting',
    '/reports': 'Reports',
    '/banking': 'Banking',
    '/settings': 'Settings',
  };

  const renderSkeletonRows = () =>
    [...Array(6)].map((_, i) => (
      <tr key={i} className={classes.tableRow}>
        {Array.from({ length: 7 }).map((__, j) => (
          <td key={j} className={classes.tableCell}>
            <div className={classes.skeletonBox}></div>
          </td>
        ))}
      </tr>
    ));
  // const handleSubmit = (formData) => {
  //   console.log('Form submitted:', formData);
  //   setIsModalOpen(false);
  // };

  return (
    <div>
      <div>
        <SupplierModal 
          show={showSupplierModal} 
          onHide={handleModalClose}
          editMode={!!editingSupplier}
          supplierData={editingSupplier}
          onSupplierUpdated={handleSupplierUpdated}
        />
        <HeaderNav activePage={pageMap[location.pathname]} />
        <div className={classes.Container}>
          <div className={classes.actions}>
            <Link to='/transactions/sales-invoice/sales'><button className={classes.btns}>Sales Invoice</button></Link>
            <Link to='/inventory/purchaseOrder'><button className={classes.btns}>Purchase order</button></Link>
            <button className={classes.btnst}>Supplier</button>
            <Link to='/settings/product-services'><button className={`${classes.btns} ${classes.greens}`}>Product & Services</button></Link>
          </div>

          <header className={classes.Header}>
            <h2 className={classes.Title}>Suppliers</h2>
            <h1 className={classes.Titles}>
              Manage your supplier's transactions, supplier's invoices, and payments.
            </h1>
          </header>

          <div className={classes.entrjj}>
            <div className={classes.allkads}>
              <div className={classes.thrdkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Total Supplier</p>
                  <p className={classes.kdptg1}>{selectedMetrics?.total_suppliers?.toLocaleString() ?? '0'}</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Available Suppliers</p>
                  </div>
                </div>
              </div>
              <div className={classes.frtkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>This Month Expenses</p>
                  <p className={classes.kdptg2}>{selectedMetrics?.expenses?.toLocaleString() ?? '0'}</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Total Spent</p>
                  </div>
                </div>
              </div>
              {/* <div className={classes.fiftkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Replenishments</p>
                <p className={classes.kdptg3}>{selectedMetrics?.replenishments?.toLocaleString() ?? '0'}</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This Month</p>
                </div>
              </div>
            </div> */}
              <div className={classes.frstkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Transactions</p>
                  <p className={classes.kdptg4}>{selectedMetrics?.transactions?.toLocaleString() ?? '0'}</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This Month</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className={classes.headerActions}>
            <div className={classes.actionsRight}>
              <div className={classes.inputWrapper}>
                <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                <input type="text" className={classes.searchBar} placeholder="Search all entries" />
              </div>
              <div className={classes.selectWrapper}>
                <select className={classes.dropdown}>
                  <option value="">All Methods</option>
                  <option value="Paid">Paid</option>
                  <option value="Pending">Pending</option>
                  <option value="Overdue">Overdue</option>
                  <option value="Draft">Draft</option>
                </select>
                <span className={classes.dropdownArrow}>▼</span>
              </div>
              <div className={classes.inputWrapper}>
                <input type="text" className={classes.searchBars} placeholder="Filter..." />
                <img src={filter} alt="Filter" className={classes.inputIcon} />
              </div>
            </div>
            <div className={classes.btnsMain}>
              <button onClick={() => setShowUploadModal(true)} className={classes.uploadBtn}> Upload Supplier</button>
              <button onClick={() => setShowSupplierModal(true)} className={classes.btnss}>
                + New Supplier
              </button>
              {/* <button onClick={() => setIsModalOpen(true)} className={classes.btnss}>
                + Supplier Payment
              </button> */}

            </div>
          </div>



          {error ? (
            <p style={{ color: "red", padding: "10px" }}>{error}</p>
          ) : (
            <table className={classes.table}>
              <thead>
                <tr className={classes.tableHeader}>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Balance</th>
                  <th>No. of Transactions</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading
                  ? renderSkeletonRows()
                  : customers.map((customer, index) => (
                    <tr key={customer.id || index} className={classes.tableRow}>
                      <td className={classes.tableCell}>{index + 1}</td>
                      <td className={classes.tableCell}>{customer.name}</td>
                      <td className={classes.tableCell}>{customer.email || '—'}</td>
                      <td className={classes.tableCell}>{customer.phone_number || '—'}</td>
                      <td className={classes.tableCell} style={{ textAlign: 'right' }}>
                        {Number(customer.balance || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
                      </td>
                      <td className={classes.tableCell}>{customer.ledgers?.length || 0}</td>
                      <td className={classes.tableCell}>
                        <div className={classes.actionIcons}>
                          <Eye size={16} style={{ color: 'rgba(22, 163, 74, 1)' }} />
                          <Edit 
                            size={16} 
                            style={{ margin: '0 8px', color: 'rgba(37, 99, 235, 1)', cursor: 'pointer' }}
                            onClick={() => handleEditSupplier(customer)}
                          />
                          <Trash size={16} style={{ color: 'rgb(255, 2, 2)' }} />
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>

        <table className={classes.footerTable}>
          <tfoot>
            <tr>
              <td>First</td>
              <td className={`${classes.page} ${classes.activePage}`}>1</td>
              <td className={classes.page}>2</td>
              <td>Last</td>
            </tr>
            <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>
          </tfoot>
        </table>
      </div>
      {/* <PaymentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmit}
      /> */}

      {/* Upload Supplier Modal */}
      <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Suppliers</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You can download the supplier template, fill it, then upload it here.</p>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            <button
              className={classes.uploadBtn}
              onClick={async () => {
                try {
                  const res = await api.get(`/v1/download-supplier-template`, {
                    responseType: 'blob',
                  });
                  const url = window.URL.createObjectURL(new Blob([res.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  // try to extract filename from headers
                  const cd = res.headers['content-disposition'];
                  let filename = 'supplier_template.xlsx';
                  if (cd) {
                    const m = cd.match(/filename\*=UTF-8''(.+)$|filename="?([^";]+)"?/i);
                    if (m) filename = decodeURIComponent(m[1] || m[2]);
                  }
                  link.setAttribute('download', filename);
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                  window.URL.revokeObjectURL(url);
                } catch (err) {
                  console.error('Download template failed', err?.response || err.message || err);
                  swal('Error', 'Failed to download template', 'error');
                }
              }}
            >
              Download Template
            </button>
          </div>

          <Form.Group controlId="formFile">
            <Form.Label>Choose filled template file</Form.Label>
            <Form.Control
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={(e) => setUploadFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <button className={classes.modalSecondary} onClick={() => setShowUploadModal(false)}>Close</button>
          <button
            className={classes.modalPrimary}
            onClick={async () => {
              if (!uploadFile) { swal('Error', 'Please choose a file to upload', 'error'); return; }
              setUploadLoading(true);
                try {
                const fd = new FormData();
                fd.append('file', uploadFile);
                const res = await api.post(`/v1/beneficiary/upload`, withCompanyId(fd), {
                  headers: { 'Content-Type': 'multipart/form-data' },
                });
                swal('Success', res.data?.message || 'Uploaded suppliers successfully', 'success');
                setShowUploadModal(false);
                setUploadFile(null);
                // refresh suppliers list without reloading the page
                await fetchCustomers();
              } catch (err) {
                console.error('Upload failed', err?.response?.data || err.message || err);
                const msg = err.response?.data?.message || 'Failed to upload suppliers';
                swal('Error', msg, 'error');
              } finally {
                setUploadLoading(false);
              }
            }}
            disabled={uploadLoading}
          >
            {uploadLoading ? 'Uploading...' : 'Upload'}
          </button>
        </Modal.Footer>
      </Modal>

      <Footer />

    </div>

  );
};

export default Suppliers;
